import { Avatar, IconButton } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../common/contexts/userContext";
import TournamentBar from "../common/worldcup/TournamentBar";
import "./MobileApp.scss";

const HomePageHeader: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  return (
    <div className="homePageHeader__root">
      <div className="homePageHeader__bar">
        <div className="homePageHeader__brand">
          <img
            src="./images/logo_cropped.png"
            alt="Typer logo"
            className="homePageHeader__logo"
          />
          <div className="homePageHeader__brandText">
            <span className="homePageHeader__title">Typer</span>
            <span className="homePageHeader__subtitle">World Cup 2026</span>
          </div>
        </div>
        <IconButton
          aria-label="Profile"
          onClick={() => navigate("/profile")}
          sx={{ p: 0 }}
        >
          <Avatar src={user.avatarUrl} className="homePageHeader__avatar" />
        </IconButton>
      </div>
      <TournamentBar compact />
    </div>
  );
};

export default HomePageHeader;
